import { z } from 'zod'

// Schéma partagé du formulaire catégorie (validation Zod, sans dépendance à react-hook-form).
export const zCategoryForm = z.object({
  categoryId: z.number().nullable(),
  description: z.string().nullable(),
  image: z.instanceof(File).nullable(),
  name: z.string().nonempty().max(30),
  rank: z.string().nullable(),
})

export type CategoryForm = z.infer<typeof zCategoryForm>
